// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"5ea85f19","117":"28977d93","377":"53f8299b","394":"192aa11d","453":"56714c60","594":"44d4f319","625":"8c1c0344","662":"d9d35dd0","746":"936a82f1","912":"45a76e78","960":"edda9e63","981":"283960b5"}[chunkId] + ".chunk.js";
};